module.exports = __webpack_public_path__ + "static/6-06cd01c7d11265f0444c3adc9acdfa60.jpg";